import { useMemo } from 'react';
import { useCurrentUser } from './useCurrentUser';
import useAsset from './useAsset';

export const useCanCreateRecurringProjects = () => {
  const { user } = useCurrentUser();
  const { constants } = useAsset();
  const canCreateRecurring = useMemo(() => {
    if (!user) return false;
    const { role } = user.organization_membership;
    const { is_managed } = user.organization;
    return (
      (!!is_managed && role === constants.ORGANIZATION_ROLE_CUSTOMER_SUCCESS) ||
      (user.is_ops && role !== constants.ORGANIZATION_ROLE_CUSTOMER_SUCCESS)
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(user), constants]);

  return { canCreateRecurring };
};
